export function pickHeader(componentName) {
  switch(componentName) {
    case "navigation-ramos": return import(/* webpackChunkName: "navigation-ramos" */ './components/header-themes/ramos/header-template');
    case "navigation-ronaldo": return import(/* webpackChunkName: "navigation-ronaldo" */ './components/header-themes/ronaldo/header-template');
    case "navigation-torres": return import(/* webpackChunkName: "navigation-torres" */ './components/header-themes/torres/header-template');
    case "navigation-chicha": return import(/*webpackChunkName: "navigation-chicha"
      */'./components/header-themes/chicha/header-template');
    case "navigation-gerrard": return import(/*webpackChunkName: "navigation-gerrard"
      */'./components/header-themes/gerrard/header-template');
    default: return import(/* webpackChunkName: "navigation-default" 
      */ './components/header-themes/navigation-default');
  }
}
